import '../styles/fonts.css';
import '../styles/HomeBreak.css';
import React from "react";

export default function HomeBreak() {
    return (
        <>
            <section className="break-section">
                <div className="break-content">


                </div>
            </section>
        </>
    )
}